import { create } from 'zustand';

interface VoteModalStore {
  isOpen: boolean;
  contestantId: string | null;
  setOpen: (isOpen: boolean, contestantId?: string) => void;
}

export const useVoteModalStore = create<VoteModalStore>((set) => ({
  isOpen: false,
  contestantId: null,
  setOpen: (isOpen: boolean, contestantId?: string) => set({ 
    isOpen, 
    contestantId: contestantId || null 
  }),
}));
